module.exports = __webpack_public_path__ + "img/B6.df4cb543.png";